import { render, staticRenderFns } from "./FormGroupedRequirementSetSelect.vue?vue&type=template&id=38906b0a&"
import script from "./FormGroupedRequirementSetSelect.vue?vue&type=script&lang=js&"
export * from "./FormGroupedRequirementSetSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports